'use client';

import { SessionProvider } from '@/compat/auth';
import { ThemeProvider } from 'next-themes';
import { ReactNode } from 'react';
import { ApiProvider } from '@pilot/api';
import { ConfigProvider, AppConfig } from '@/lib/config/context';

interface ProvidersProps {
  children: ReactNode;
  config: AppConfig;
}

export function Providers({ children, config }: ProvidersProps) {
  return (
    <ApiProvider>
      <ConfigProvider config={config}>
        <SessionProvider>
          <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
            {children}
          </ThemeProvider>
        </SessionProvider>
      </ConfigProvider>
    </ApiProvider>
  );
}
